/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TvActivateRouteImport } from './routes/tv-activate'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WatchTmdbIdRouteImport } from './routes/watch.$tmdbId'
import { Route as WatchHistorySourcesTmdbIdRouteImport } from './routes/watch-history-sources.$tmdbId'
import { Route as AuthSigninRouteImport } from './routes/auth.signin'
import { Route as MoviesBrowseTypeFilterRouteImport } from './routes/movies.browse.$type.$filter'

const TvActivateRoute = TvActivateRouteImport.update({
  id: '/tv-activate',
  path: '/tv-activate',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/admin.lazy').then((d) => d.Route))
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WatchTmdbIdRoute = WatchTmdbIdRouteImport.update({
  id: '/watch/$tmdbId',
  path: '/watch/$tmdbId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/watch.$tmdbId.lazy').then((d) => d.Route))
const WatchHistorySourcesTmdbIdRoute =
  WatchHistorySourcesTmdbIdRouteImport.update({
    id: '/watch-history-sources/$tmdbId',
    path: '/watch-history-sources/$tmdbId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/auth/signin',
  path: '/auth/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const MoviesBrowseTypeFilterRoute = MoviesBrowseTypeFilterRouteImport.update({
  id: '/movies/browse/$type/$filter',
  path: '/movies/browse/$type/$filter',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/movies.browse.$type.$filter.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/admin': typeof AdminRoute
  '/tv-activate': typeof TvActivateRoute
  '/auth/signin': typeof AuthSigninRoute
  '/watch-history-sources/$tmdbId': typeof WatchHistorySourcesTmdbIdRoute
  '/watch/$tmdbId': typeof WatchTmdbIdRoute
  '/movies/browse/$type/$filter': typeof MoviesBrowseTypeFilterRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/admin': typeof AdminRoute
  '/tv-activate': typeof TvActivateRoute
  '/auth/signin': typeof AuthSigninRoute
  '/watch-history-sources/$tmdbId': typeof WatchHistorySourcesTmdbIdRoute
  '/watch/$tmdbId': typeof WatchTmdbIdRoute
  '/movies/browse/$type/$filter': typeof MoviesBrowseTypeFilterRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/admin': typeof AdminRoute
  '/tv-activate': typeof TvActivateRoute
  '/auth/signin': typeof AuthSigninRoute
  '/watch-history-sources/$tmdbId': typeof WatchHistorySourcesTmdbIdRoute
  '/watch/$tmdbId': typeof WatchTmdbIdRoute
  '/movies/browse/$type/$filter': typeof MoviesBrowseTypeFilterRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate'
    | '/admin'
    | '/tv-activate'
    | '/auth/signin'
    | '/watch-history-sources/$tmdbId'
    | '/watch/$tmdbId'
    | '/movies/browse/$type/$filter'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate'
    | '/admin'
    | '/tv-activate'
    | '/auth/signin'
    | '/watch-history-sources/$tmdbId'
    | '/watch/$tmdbId'
    | '/movies/browse/$type/$filter'
  id:
    | '__root__'
    | '/'
    | '/activate'
    | '/admin'
    | '/tv-activate'
    | '/auth/signin'
    | '/watch-history-sources/$tmdbId'
    | '/watch/$tmdbId'
    | '/movies/browse/$type/$filter'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivateRoute: typeof ActivateRoute
  AdminRoute: typeof AdminRoute
  TvActivateRoute: typeof TvActivateRoute
  AuthSigninRoute: typeof AuthSigninRoute
  WatchHistorySourcesTmdbIdRoute: typeof WatchHistorySourcesTmdbIdRoute
  WatchTmdbIdRoute: typeof WatchTmdbIdRoute
  MoviesBrowseTypeFilterRoute: typeof MoviesBrowseTypeFilterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/tv-activate': {
      id: '/tv-activate'
      path: '/tv-activate'
      fullPath: '/tv-activate'
      preLoaderRoute: typeof TvActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/watch/$tmdbId': {
      id: '/watch/$tmdbId'
      path: '/watch/$tmdbId'
      fullPath: '/watch/$tmdbId'
      preLoaderRoute: typeof WatchTmdbIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/watch-history-sources/$tmdbId': {
      id: '/watch-history-sources/$tmdbId'
      path: '/watch-history-sources/$tmdbId'
      fullPath: '/watch-history-sources/$tmdbId'
      preLoaderRoute: typeof WatchHistorySourcesTmdbIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/auth/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/movies/browse/$type/$filter': {
      id: '/movies/browse/$type/$filter'
      path: '/movies/browse/$type/$filter'
      fullPath: '/movies/browse/$type/$filter'
      preLoaderRoute: typeof MoviesBrowseTypeFilterRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivateRoute: ActivateRoute,
  AdminRoute: AdminRoute,
  TvActivateRoute: TvActivateRoute,
  AuthSigninRoute: AuthSigninRoute,
  WatchHistorySourcesTmdbIdRoute: WatchHistorySourcesTmdbIdRoute,
  WatchTmdbIdRoute: WatchTmdbIdRoute,
  MoviesBrowseTypeFilterRoute: MoviesBrowseTypeFilterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
